<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Reservations
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left booking_content_wrapper mb-2"
        cols="12"
        md="12"
      >
        <b-col
          class="content-header-right mb-2 ml-auto"
          cols="12"
          md="12"
        >
          <b-button
            v-if="canViewThisAction('create', 'LotReservation') || canViewThisAction('create-staff-hold', 'LotReservation')"
            variant="success"
            class="mobile_create_button"
            :to="{ name: 'agencies-reservation-create' }"
            style="padding: 0.786rem 0.7rem;"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle d-md-block d-none">Create new Reservation</span>
            <span class="align-middle d-md-none d-block">New</span>
          </b-button>
        </b-col>
        <b-dropdown
          v-if="isMobile()"
          :text="currentTabTitle"
          variant="outline-primary"
        >
          <b-dropdown-item
            v-for="(tab, index) in pageTabs"
            :key="index"
            @click="changeRoute(tab.param)"
          >
            {{ tab.title }} ({{ tab.count }})
          </b-dropdown-item>
        </b-dropdown>
        <b-tabs
          pills
          class="booking__content pr-tabs"
          :nav-class="[isMobile() ? 'd-none' : '']"
        >
          <b-tab
            :active="$route.params.type == 'reserved'"
            lazy
            @click="changeRoute('reserved')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Reserved <span class="rounded-number">{{ reservedReservationCount }}</span></span>
            </template>
            <current-reservation
              class="mt-2 pt-75"
              :status-options="statusOptions"
              :product-options="productOptions"
              :lot-type-options="lotTypeOptions"
              @emitCountReservation="countReservations"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'staff-hold'"
            lazy
            @click="changeRoute('staff-hold')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Staff Hold <span class="rounded-number">{{ staffHoldReservationCount }}</span></span>
            </template>
            <staff-hold-reservation
              class="mt-2 pt-75"
              :status-options="statusOptions"
              :product-options="productOptions"
              :lot-type-options="lotTypeOptions"
              @emitCountReservation="countReservations"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'submission-hold'"
            lazy
            @click="changeRoute('submission-hold')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Submission Hold <span class="rounded-number">{{ submissionHoldReservationCount }}</span></span>
            </template>
            <submission-hold-reservation
              class="mt-2 pt-75"
              :status-options="statusOptions"
              :product-options="productOptions"
              :lot-type-options="lotTypeOptions"
              @emitCountReservation="countReservations"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'processing'"
            lazy
            @click="changeRoute('processing')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Processing <span class="rounded-number">{{ processingReservationCount }}</span></span>
            </template>
            <processing-reservation
              class="mt-2 pt-75"
              :status-options="statusOptions"
              :product-options="productOptions"
              :lot-type-options="lotTypeOptions"
              @emitCountReservation="countReservations"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'past'"
            lazy
            @click="changeRoute('past')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Past <span class="rounded-number">{{ pastReservationCount }}</span></span>
            </template>
            <past-reservation
              class="mt-2 pt-75"
              :product-options="productOptions"
              :lot-type-options="lotTypeOptions"
              @emitCountReservation="countReservations"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BButton, BCol, BTab, BTabs, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CurrentReservation from './reserved/CurrentReservation.vue'
import PastReservation from './past/PastReservation.vue'
import StaffHoldReservation from './staff-hold/StaffHoldReservation.vue'
import SubmissionHoldReservation from './submission-hold/SubmissionHoldReservation.vue'
import ProcessingReservation from './processing/ProcessingReservation.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTab,
    BTabs,
    BDropdown,
    BDropdownItem,

    CurrentReservation,
    PastReservation,
    StaffHoldReservation,
    SubmissionHoldReservation,
    ProcessingReservation,
  },
  data() {
    return {
      reservedReservationCount: 0,
      pastReservationCount: 0,
      staffHoldReservationCount: 0,
      submissionHoldReservationCount: 0,
      processingReservationCount: 0,
      currentTabTitle: '',
      pageTabs: [
        {
          title: 'Reserved',
          param: 'reserved',
          count: 0,
        },
        {
          title: 'Staff Hold',
          param: 'staff-hold',
          count: 0,
        },
        {
          title: 'Submission Hold',
          param: 'submission-hold',
          count: 0,
        },
        {
          title: 'Processing',
          param: 'processing',
          count: 0,
        },
        {
          title: 'Past',
          param: 'past',
          count: 0,
        },
      ],
      statusOptions: [
        { title: 'Reserved', code: 'Reserved' },
        { title: 'Released', code: 'Released' },
        { title: 'Staff Hold', code: 'Staff Hold' },
        { title: 'Submission Hold', code: 'Submission Hold' },
        { title: 'Processing', code: 'Processing' },
      ],
      lotTypeOptions: [
        { title: 'Single', code: 'SINGLE' },
        { title: 'Double', code: 'DOUBLE' },
        { title: 'Twin Single', code: 'TWIN SINGLE' },
        { title: 'Twin Double', code: 'TWIN DOUBLE' },
        { title: 'Family', code: 'FAMILY' },
        { title: 'Super Family', code: 'SUPER FAMILY' },
      ],
      productOptions: [
        { title: 'Niche', code: '1' },
        { title: 'Pedestal', code: '5' },
        { title: 'Little Buddha', code: '6' },
      ],
    }
  },
  watch: {
    $route() {
      const param = this.$route.params.type
      const currentTab = this.pageTabs.find(o => o.param === param)
      if (currentTab) {
        this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
      }
    },
  },
  beforeMount() {
    this.countReservations()
  },

  methods: {
    canViewThisAction,
    changeRoute(param) {
      this.$router.replace({
        params: {
          type: param,
        },
        query: {},
      })
    },
    countReservations() {
      this.$http.get('reservation/agent/reservation/counts')
        .then(response => {
          this.reservedReservationCount = response.data.reservedReservationCount
          this.pastReservationCount = response.data.pastReservationCount
          this.staffHoldReservationCount = response.data.staffHoldReservationCount
          this.submissionHoldReservationCount = response.data.submissionHoldReservationCount
          this.processingReservationCount = response.data.processingReservationCount

          this.pageTabs.forEach(element => {
            if (element.title === 'Reserved') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.reservedReservationCount
            } else if (element.title === 'Past') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.pastReservationCount
            } else if (element.title === 'Staff Hold') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.staffHoldReservationCount
            } else if (element.title === 'Submission Hold') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.submissionHoldReservationCount
            } else if (element.title === 'Processing') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.processingReservationCount
            }
          })

          const param = this.$route.params.type

          const currentTab = this.pageTabs.find(o => o.param === param)
          if (currentTab) {
            this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style scoped>
  .rounded-number {
    height: 24px;
    width: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    color:#104D9D;
  }
</style>
